import * as Yup from 'yup';
import {
  getStringSchema,
  getNumberSchema,
  getPercentSchema,
  getSelectSchema,
} from 'src/compass/shared/schemas';
import { AmountType } from './AmountPerTradeOrPercent';

const AsOfAddit = Yup.array().of(
  Yup.object().shape({
    employeeId: getSelectSchema('Employee'),
    amountType: getSelectSchema('Amount Type'),
    percentage: Yup.number().when('amountType', (amountType, schema) =>
      amountType[0] === AmountType.Percentage
        ? getPercentSchema('Percentage')
        : schema.default(0).transform(() => 0)
    ),
    amountPerTrade: Yup.number().when('amountType', (amountType, schema) =>
      amountType[0] === AmountType.AmountPerTrade
        ? getNumberSchema('$/Trade')
        : schema.default(0).transform(() => 0)
    ),
  })
);

export const CMESalesCodeSchema = Yup.object().shape({
  description: getStringSchema(50, 'Description').notRequired(),
  asOf: Yup.object({
    payoutRate: getPercentSchema('Payout Rate').integer('Payout Rate must be an integer.'),
    asOfAddit: AsOfAddit,
  }),
});
